import request from '@/utils/request'

// 获取权限组列表
export function getPrivilegeGroupList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.listPrivilegeGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存权限组
export function savePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.savePrivilegeGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新权限组
export function updatePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.updatePrivilegeGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除权限组
export function deletePrivilegeGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.deletePrivilegeGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取未添加的权限列表
export function listNoAddPrivilege(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.listNoAddPrivilege',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 添加权限到权限组
export function addPrivilegeToGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.addPrivilegeToGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 从权限组删除权限
export function deletePrivilegeFromGroup(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.deletePrivilegeFromGroup',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取权限列表
export function getPrivilegeList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/privilegeGroup.listPrivilege',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}